import {
  TBarcodeScannerLogColumnKey,
} from './debug-barcode-scanner.ts';

const columns: Record<TBarcodeScannerLogColumnKey, string> = {
  timestampEpochMilliseconds: 'Znacznik czasu',
  eventType: 'Zdarzenie',
  characterLabel: 'Znak',
  isControlCharacter: 'Znak sterujacy',
  key: 'Klawisz',
  code: 'Kod',
  keyCode: 'Kod klawisza',
  modifierList: 'Modyfikatory',
  inputType: 'Typ wejscia',
  inputValueSnapshot: 'Wartosc pola',
};

export default {
  description: 'Kliknij w pole ponizej i zeskanuj kod kreskowy, aby zobaczyc kazde zdarzenie klawiatury i wejscia wywolywane przez przegladarke, w kolejnosci wystapienia. Najnowsze zdarzenie jest wyswietlane na gorze dziennika. Niedrukowalne znaki sterujace sa wyswietlane za pomoca standardowego skrotu, na przyklad <GS> dla znaku Group Separator (0x1D).',
  scanInputPlaceholder: 'Kliknij tutaj i zeskanuj kod kreskowy',
  eventCount: 'Zarejestrowano zdarzen: {count}',
  copyLogButtonLabel: 'Kopiuj dziennik',
  clearButtonLabel: 'Wyczysc',
  emptyLog: 'Brak zdarzen. Zeskanuj kod kreskowy, aby rozpoczac rejestrowanie.',
  columns,
};
